module.exports = __webpack_public_path__ + "img/rightarrow.71936c01.svg";